import { IToast, ToastType } from 'store/ui/toasts/toastsTypes';
import * as actionTypes from 'constants/action-types';
import { DevOptions, loadDevOptions } from 'utils/localStorageUtil';
import { showNotificationError } from '@blazemeter/blaze-ct-ui-components';
import _ from 'lodash';

export type SHOW_TOAST = 'SHOW_TOAST';
export const SHOW_TOAST: SHOW_TOAST = actionTypes.SHOW_TOAST;

export type HIDE_TOAST = 'HIDE_TOAST';
export const HIDE_TOAST: HIDE_TOAST = actionTypes.HIDE_TOAST;

export type ToastAction = {
  type: SHOW_TOAST | HIDE_TOAST;
  toast: IToast;
};

const showToast = (type: ToastType, heading: string, content?: any, timeout?: number) => ({
  type: SHOW_TOAST,
  toast: {
    timestamp: Date.now(),
    content: content,
    heading,
    type: type,
    timeout: timeout,
  },
});

export const hideToast = (toast: IToast): ToastAction => ({
  type: HIDE_TOAST,
  toast,
});

/**
 * Shows toast notification. Success, Info and Warning messages are dismissed automatically. Warning messages have to be
 * closed manually by the user.
 * @param type Success, Warning, Danger, Info
 * @param heading
 * @param content optional parameter - a string message or any component
 * @param messageTimeout optional parameter
 */
export const showToastNotification = (
  type: ToastType,
  heading: string,
  content?: any,
  messageTimeout?: number,
): any => (dispatch: any): IToast | null => {
  // Look in the local storage at devOptions item,
  // if sticky toasts are enabled, set timeout to 0, so it will stay on the screen
  const devOptions: DevOptions | undefined = loadDevOptions();
  if (devOptions && devOptions.silentErrors === true) {
    return;
  }
  if (devOptions && devOptions.stickyToasts === true) {
    messageTimeout = 0;
  }

  // For error toast message, use BlazeCT common UI utility (using Bootstrap Notify)
  if (type === ToastType.Danger) {
    const msgContent = !_.isEmpty(content) ? content : '';
    const message: string = !_.isEmpty(heading) ? heading + '. ' + msgContent : msgContent;
    showNotificationError({ message: message });
    return null;
  } else {
    // For any others, use our current solution
    const toastAction = showToast(type, heading, content, messageTimeout);
    dispatch(toastAction);

    if (messageTimeout && messageTimeout !== 0) {
      // Toasts clean up logic, deletes toast from the dom after particular timeout
      const timeOut = messageTimeout ? messageTimeout + 3000 : 8000;
      setTimeout(() => {
        dispatch(hideToast(toastAction.toast));
      }, timeOut);
    }
    return toastAction.toast;
  }
};
